import { render, staticRenderFns } from "./AamsRegSealUsageRecord.vue?vue&type=template&id=79628730&scoped=true&"
import script from "./AamsRegSealUsageRecord.vue?vue&type=script&lang=js&"
export * from "./AamsRegSealUsageRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79628730",
  null
  
)

export default component.exports